import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Subestatus } from '@p-p-portafolio/interfaces/subestatus';
import { EntityOperationResult } from '@shared/interfaces/responses/entity-operation-result';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SubestatusService {

  private baseUrl = environment.apiBaseUrl + 'api/subestatus';

  constructor(private http: HttpClient) { }

  form: UntypedFormGroup = new UntypedFormGroup({
    sEmpresa: new UntypedFormControl(null, [Validators.required]),
    codigoEstado: new UntypedFormControl('', [Validators.maxLength(40)]),
    descripcion: new UntypedFormControl(null),
    subEstatusCredito: new UntypedFormControl(null)
  });

  initializeFormGroup() {
    this.form.setValue({
      sEmpresa: '',
      codigoEstado: '',
      descripcion: '',
      subEstatusCredito: ''
    });
  }

  populateForm(entity: Subestatus) {
    this.form.setValue(entity);
  }

  getAll(sEmpresa: string, codigoEstado: string){
    const url = `${this.baseUrl}/${sEmpresa}/${codigoEstado}`;
    return this.http.get<Subestatus[]>(url);
  }

  getById(id: string) {
    const url = `${this.baseUrl}/${id}`;
    return this.http.get<Subestatus>(url);
  }

  add(entity: Subestatus) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };

    const url = `${this.baseUrl}/add`;
    return this.http.post<EntityOperationResult>(url, entity, httpOptions);
  }

  update(entity: Subestatus) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json'
      })
    };



    const url = `${this.baseUrl}/upd`;
    return this.http.put<EntityOperationResult>(url, entity, httpOptions);
  }

  delete(entity: Subestatus) {
    const url = `${this.baseUrl}/del`;
    return this.http.request<EntityOperationResult>('delete', url, { body: entity });
  }
}
